import(/* webpackMode: "eager" */ "/vercel/path0/apps/hsiyc/mui-variables.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@mui+material-nextjs@7.3.8_@emotion+cache@11.14.0_@emotion+react@11.14.0_@types+react@1_0ce35d46dcfc1b85f3917850e272dbdd/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
